/* eslint-disable */
import * as React from 'react';
import injectSheet from 'react-jss';
interface Props {
  currentStep?: number;
  currentStepId?: any;
  formTitle?: String;
  formSubTitle?: String;
  classes?: any;
  logo?: string;
}

const styleSheet = {
  container: {
    display: 'flex',
    fontFamily: 'CircularStd, sans-serif',
    textAlign: 'left',
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    paddingBottom: 80,
    padding: '0 30px',
    '@media (max-width: 1000px)': {
      width: '520px',
      margin: '0 auto',
      flexDirection: 'column',
    },
    '@media (max-width: 900px)': {
      padding: 0,
    },
    '@media (max-width: 740px)': {
      width: '100%',
    },
  },
  containerH1: {
    fontFamily: 'CircularStdBold, sans-serif',
    fontSize: '36px',
    fontWeight: 'bold',
    color: '#223762',
    '@media (max-width: 900px)': {
      fontSize: '26px',
      marginBottom: '10px',
    },
  },
  containerH2: {
    fontSize: '24px',
    fontWeight: 500,
    color: '#6373a4',
    '@media (max-width: 900px)': {
      fontSize: '18px',
      fontWeight: 'bold',
      margin: 0,
    },
  },
  logo: {
    objectFit: 'contain',
    paddingLeft: '50px',
    maxWidth: '240px',
    maxHeight: '240px',
    '@media (max-width: 1000px)': {
      paddingLeft: 0,
      order: -1,
    },
  },
};

const header: React.FC<Props> = props => {
  const [passedInLogo, setPassedInLogo] = React.useState(null);
  const [passedInTitle, setPassedInTitle] = React.useState(null);
  const [passedInSubTitle, setPassedInSubTitle] = React.useState(null);
  const [showLogo, setShowLogo] = React.useState(true);

  React.useEffect(() => {
    window.addEventListener('message', checkForMessage);
    return () => {
      window.removeEventListener('message', checkForMessage);
    };
  }, []);

  const checkForMessage = (event: any) => {
    if (event.data.message === 'updateLogo') {
      if (event.data.logoData) {
        setPassedInLogo(event.data.logoData);
        setShowLogo(true);
      } else {
        setShowLogo(false);
      }
    }
    if (event.data.message === 'welcomeCopy' && event.data.welcomeData) {
      setPassedInTitle(event.data.welcomeData.title);
      setPassedInSubTitle(event.data.welcomeData.subtitle);
    }
  };

  return (
    <div className={props.classes.container}>
      <div style={{ width: '100%' }}>
        <h1 className={props.classes.containerH1}>
          {passedInTitle || props.formTitle}
        </h1>
        <h2 className={props.classes.containerH2}>
          {passedInSubTitle || props.formSubTitle}
        </h2>
      </div>

      {(props.logo || passedInLogo) && showLogo && (
        <img
          className={props.classes.logo}
          src={passedInLogo || props.logo}
          data-object-fit="contain"
        />
      )}
    </div>
  );
};

export default injectSheet(styleSheet)(header);
